// extracted by mini-css-extract-plugin
export default {"HeadingContainer":"Heading_HeadingContainer__KZJWB","Subheading":"Heading_Subheading__PO2aX"};